import React, { useState } from "react";
import styled from "@emotion/styled";
import CrossIcon from "@assets/icons/cross.svg";
import { colors } from "@ui/style/colors";

interface CrossButtonProps {
	onClick: () => void;
	className?: string;
}

export const CrossButton: React.FC<CrossButtonProps> = ({ onClick, className }) => {
	const [isHovered, setIsHovered] = useState(false);

	return (
		<Container
			className={className}
			onClick={onClick}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
		>
			<CrossIcon width={16} height={16} color={isHovered ? colors.white : colors.grey80} />
		</Container>
	);
};

const Container = styled.div`
	display: grid;
	place-items: center;
	cursor: pointer;
	width: 24px;
	height: 24px;
	background-color: var(--primary-10);
	border-top-right-radius: 8px;
	border-bottom-left-radius: 8px;

	&:hover {
		background-color: var(--rejection);
	}
`;
